import { FC, ReactNode } from "react";
import { Autocomplete, TextField } from "@mui/material";
import {
  createAutocompleteFieldFilterWithFallback,
  getAutocompleteNoOptionsText,
  isOptionEqualById,
} from "./autocompleteHelpers";
import { TradeName } from "../../../api/types";

interface TradeNameAutocompleteFieldProps {
  id: string;
  value: TradeName | null;
  inputValue: string;
  onChange?: (value: TradeName | null) => void;
  onInputChange?: (value: string, reason: "input" | "clear" | "reset" | "removeOption") => void;
  onBlur?: () => void;
  options?: TradeName[];
  isLoading?: boolean;
  width?: string;
  label?: string;
  name?: string;
  error?: boolean;
  helperText?: ReactNode;
  listboxMaxHeight?: string;
}

const tradeNameFilter = createAutocompleteFieldFilterWithFallback<TradeName>(
  "tradenameNameLower",
  "tradenameName",
);

const TradeNameAutocompleteField: FC<TradeNameAutocompleteFieldProps> = ({
  id,
  value,
  inputValue,
  onChange,
  onInputChange,
  onBlur,
  options = [],
  isLoading = false,
  width = "20rem",
  label = "Trade Name",
  name,
  error = false,
  helperText = "",
  listboxMaxHeight = "300px",
}) => {
  return (
    <Autocomplete
      noOptionsText={getAutocompleteNoOptionsText("Trade Names", isLoading)}
      id={id}
      value={value}
      inputValue={inputValue}
      onChange={(_e, option) => onChange?.(option)}
      onInputChange={(_e, nextValue, reason) => onInputChange?.(nextValue, reason)}
      onBlur={onBlur}
      disablePortal
      options={options}
      filterOptions={tradeNameFilter}
      getOptionKey={(option) => option?.id ?? ""}
      getOptionLabel={(option) => option?.tradenameName ?? ""}
      isOptionEqualToValue={isOptionEqualById}
      sx={{ width }}
      ListboxProps={{
        style: { maxHeight: listboxMaxHeight },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          name={name}
          variant="outlined"
          size="small"
          margin="none"
          label={label}
          error={error}
          helperText={helperText}
        />
      )}
      autoSelect
    />
  );
};

export default TradeNameAutocompleteField;
